import { useStore as useZustandStore } from 'zustand';

import { IStore } from '@/state/slices/typings';
import store from '@/state/vanilla';

const useStore = <T>(selector: (state: IStore) => T): T =>
	useZustandStore(store, selector);

export default useStore;
